module.exports = __webpack_public_path__ + "img/canal.45fe2b12.webp";